<div class="modal-content">
  <div class="modal-header">
    <p class="modal-title"><strong>{{getTitleKey() | translate}}</strong></p>
    <button type="button" class="close" (click)="closeDialog()" aria-label="Close" [disabled]="savingInProgress">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <mat-dialog-content [ngStyle]="{'overflow': formComponent?.hasSelectedWorkflow ? 'auto' : 'visible'}">
    <app-process-base-form
      #formComponent
      [data]="data"
      (saving)="savingInProgress = $event"
      (finished)="onFormFinished($event)">
    </app-process-base-form>
  </mat-dialog-content>

  <div class="modal-footer">
    <button type="button" class="btn btn-outline-primary" (click)="closeDialog()" [disabled]="savingInProgress">
      {{ 'COMMON_BUTTON_CANCEL' | translate}}
    </button>

    <button type="button" class="btn btn-primary"
            *ngIf="!readonly"
            [disabled]="savingInProgress"
            (click)="formComponent.submit()">
      {{ 'COMMON_BUTTON_SAVE' | translate}}
    </button>
  </div>
</div>
